import React, { Component, Fragment } from 'react';
import { TopUserSetupComponent } from '../components/Shared/TopUserSetupComponent';
import { trackLogout } from '../helpers/activityTracker';
import { toggleSidebar as toggleMenu } from './sidebar/useSidebarLayout';

export class TopBarComponent extends Component {
    static displayName = TopBarComponent.name;

    handleLogout = async (e) => {
        e.preventDefault();
        trackLogout();
        sessionStorage.clear();
        window.location.href = "/";
    }

    render() {
        return (
            <Fragment>
                <div className="navbar-bg"></div>
                <nav className="navbar navbar-custom navbar-expand-lg main-navbar" name="topGeneralBar">
                    <form className="form-inline mr-auto">
                        <ul className="navbar-nav mr-3">
                            <li><button type="button" className="nav-link nav-link-lg btn btn-link" aria-label="Show or hide the menu" onClick={toggleMenu}><i className="fas fa-bars"></i></button></li>
                            <li className="nav-item">
                                <h6 className='mb-0'><label id='lblPageTitle'></label></h6>
                            </li>
                        </ul>
                    </form>
                    <TopUserSetupComponent />
                </nav>
            </Fragment>
        );
    }
}
